import React, { FC } from 'react';
import { Container, ContentLoader } from './styles';

const Loader: FC = () => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 516 208">
        <path
          opacity="0.5"
          d="M208 104C208 161.438 161.438 208 104 208C46.5624 208 0 161.438 0 104C0 46.5624 46.5624 0 104 0C161.438 0 208 46.5624 208 104ZM41.6 104C41.6 138.463 69.5374 166.4 104 166.4C138.463 166.4 166.4 138.463 166.4 104C166.4 69.5374 138.463 41.6 104 41.6C69.5374 41.6 41.6 69.5374 41.6 104Z"
        />
        <rect x="246" y="2" width="12" height="12" rx="6" />
        <rect x="271" width="89" height="16" rx="8" />
        <rect x="435" width="81" height="16" rx="8" />
        <rect x="246" y="50" width="12" height="12" rx="6" />
        <rect x="271" y="48" width="89" height="16" rx="8" />
        <rect x="435" y="48" width="81" height="16" rx="8" />
        <rect x="246" y="98" width="12" height="12" rx="6" />
        <rect x="271" y="96" width="89" height="16" rx="8" />
        <rect x="435" y="96" width="81" height="16" rx="8" />
        <rect x="246" y="146" width="12" height="12" rx="6" />
        <rect x="271" y="144" width="89" height="16" rx="8" />
        <rect x="435" y="144" width="81" height="16" rx="8" />
        <rect x="246" y="194" width="12" height="12" rx="6" />
        <rect x="271" y="192" width="89" height="16" rx="8" />
        <rect x="435" y="192" width="81" height="16" rx="8" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
